import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShippingTrackingState } from "./shippingTracking.state";
import { getCargoTrackingMetadata, trackOrder } from "./shippingTracking.thunk";
import {
  CargoTrackingMetadataResponse,
  CargoTrackingResultResponse,
} from "./shippingTracking.types";

const initialState: ShippingTrackingState = {
  metadata: { data: null, error: null, status: "idle" },
  result: { data: null, error: null, status: "idle" },
};

const shippingTrackingSlice = createSlice({
  name: "shippingTracking",
  initialState,
  reducers: {
    clearResult: (state) => {
      state.result = { data: null, error: null, status: "idle" };
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getCargoTrackingMetadata.pending, (state) => {
        state.metadata.status = "loading";
        state.metadata.error = null;
      })
      .addCase(
        getCargoTrackingMetadata.fulfilled,
        (state, action: PayloadAction<CargoTrackingMetadataResponse>) => {
          state.metadata.status = "success";
          state.metadata.data = action.payload.data;
        },
      )
      .addCase(
        getCargoTrackingMetadata.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.metadata.status = "error";
          state.metadata.error = action.payload ?? "Bir hata oluştu.";
        },
      )
      .addCase(trackOrder.pending, (state) => {
        state.result.status = "loading";
        state.result.error = null;
        state.result.data = null;
      })
      .addCase(
        trackOrder.fulfilled,
        (state, action: PayloadAction<CargoTrackingResultResponse>) => {
          state.result.status = "success";
          state.result.data = action.payload.data;
        },
      )
      .addCase(
        trackOrder.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.result.status = "error";
          state.result.error = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { clearResult } = shippingTrackingSlice.actions;
export default shippingTrackingSlice.reducer;
